var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcodeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#10385a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "QR code logo -01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.94,55.44a4,4,0,0,1,1.57.31L50.8,31.06H48.74L39.08,55.62a4,4,0,0,1,1.22-.18H58.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,90.57,7.17,74.46,26.61,27.74l4.95-11.92,2.64-6.39H99.5V90.57Zm49.77-42-.5-1.26-.5,1.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.79,19.78h.37V80.23H16l.74-1.79L36.16,31.71c1.61-3.87,3.35-8.06,5-11.94ZM70.22,71l-.44-1.14L58.7,41.72Q56,34.8,53.26,27.87a.35.35,0,0,0-.38-.27H46.65a.32.32,0,0,0-.35.25c-.38,1-.78,2-1.16,3L29.46,70.66c0,.11-.08.23-.13.38h.35c1.78,0,3.55,0,5.33,0a.42.42,0,0,0,.46-.32Q37.66,65,39.86,59.19a.4.4,0,0,1,.44-.3H58.93a.42.42,0,0,1,.47.31c1.47,3.84,3,7.68,4.43,11.52a.44.44,0,0,0,.49.33c1.76,0,3.51,0,5.27,0Zm11.5,0v-6.2h-6.2V71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.22,71h-.63c-1.76,0-3.51,0-5.27,0a.44.44,0,0,1-.49-.33c-1.47-3.84-3-7.68-4.43-11.52a.42.42,0,0,0-.47-.31H40.31a.4.4,0,0,0-.44.3Q37.67,65,35.48,70.72A.42.42,0,0,1,35,71c-1.78,0-3.55,0-5.33,0h-.35c.05-.15.09-.27.13-.38L45.13,30.83c.39-1,.78-2,1.16-3a.32.32,0,0,1,.35-.25h6.23a.35.35,0,0,1,.38.27Q56,34.8,58.7,41.72L69.78,69.9ZM41.86,53.94H57.34L49.62,33.82h-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.72,71h-6.2v-6.2h6.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.86,53.94l7.66-20.12h.1l7.72,20.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeLogo);
export default __webpack_public_path__ + "static/media/qrcode_logo.03f708cd1f78a90e0d09a3f274314ec4.svg";
export { ForwardRef as ReactComponent };